module.exports = __webpack_public_path__ + "img/cookie_kingdom_logo.726abea3.jpg";